<template>
    <div id="main" class="center">
        <Header :providerInfo="null"></Header>

        <div class="page-content">
            <h1 class="title">{{$t('reset_password')}}</h1>

            <div style="margin-bottom: 2em;">
                {{$t('forgot_password_instructions')}}
            </div>

            <b-field :label="$t('affiliate_id')">
                <b-input v-model="affiliate_id" @keyup.native.enter="submit" type="text" class="login_width" required></b-input>
            </b-field>

            <ErrorMessages :errors="errors"></ErrorMessages>

            <div id="submitMessage" style="margin-top: 1em;" class="hidden">
                {{$t('forgot_password_submit_message')}}
            </div>

            <div class="button-panel"><b-button v-on:click="submit">{{$t('submit')}}</b-button></div>
        </div>

        <Footer/>
    </div>
</template>

<style>
    .hidden {
        display: none;
    }
    .center {
        margin-left: auto;
        margin-right: auto;
    }
    .page-content {
        margin-left: auto;
        margin-right: auto;
        padding-top: 50px;
        padding-bottom: 60px;
        max-width: 700px;
    }
    h1.title {
        padding-bottom: 30px;
    }
    .login_width {
        width: 400px;
    }
    .button-panel {
        margin-top: 30px;
        margin-bottom: 10px;
    }
</style>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";
    import ErrorMessages from "../components/ErrorMessages";
    import session from '../session'
    import common from "../common";

    const model = {
        affiliate_id: null,
        errors: []
    };

    function validate() {
        common.clearArray(model.errors);
        if (!model.affiliate_id) {
            model.errors.push('AFFILIATE_ID_NEEDED');
        }
        return model.errors.length === 0;
    }

    export default {
        components: {
            Header, Footer, ErrorMessages
        },

        data() {
            return model;
        },

        methods: {
            submit: function () {
                function successHandler() {
                    common.setDefaultCursor();
                    model.affiliate_id = null;
                    document.getElementById('submitMessage').classList.remove('hidden');
                }
                function errorHandler() {
                    common.setDefaultCursor();
                }
                if (validate()) {
                    const data = {
                        affiliate_id: model.affiliate_id
                    };
                    common.setWaitCursor();
                    session.post('forgot_password', data, successHandler, errorHandler, model.errors);
                }
            }
        }
    }
</script>
